import { capitalize } from 'lodash';
import * as qs from 'qs';

const EMBEDDABLE_USER_LOCAL_STORAGE_KEY = 'shippo_embeddable_user';
const LEGACY_INSTALL_INTENT = 'bm-flow';
const ORDER_DETAILS_INSTALL_INTENT = 'bm-stores-orders';
const ORDERS_LIST_INSTALL_INTENT = 'bm-stores-orders-list';

const AcceptedInstallIntents = [
  LEGACY_INSTALL_INTENT,
  ORDER_DETAILS_INSTALL_INTENT,
  ORDERS_LIST_INSTALL_INTENT,
];

export const checkForEmbeddableUser = (queryString: string): boolean => {
  const queryParams = qs.parse(queryString, {
    ignoreQueryPrefix: true,
    decoder: decodeURIComponent,
  });
  if (
    (queryParams.installIntent &&
      AcceptedInstallIntents.includes(queryParams.installIntent as string)) ||
    window.location.search.includes('Embed')
  ) {
    localStorage.setItem(EMBEDDABLE_USER_LOCAL_STORAGE_KEY, 'true');
    return true;
  } else return false;
};

export const getEmbeddableUser = (): boolean => {
  const embeddableUserValue = localStorage.getItem(EMBEDDABLE_USER_LOCAL_STORAGE_KEY);
  if (embeddableUserValue === 'true') return true;
  else return false;
};

export const removeEmbeddableUser = () => {
  localStorage.removeItem(EMBEDDABLE_USER_LOCAL_STORAGE_KEY);
};

export const refreshWithUTMParameters = (utmSource: string, embeddable: boolean) => {
  const currentParams = qs.parse(window.location.search.substring(1));
  const newParams = {
    utm_source: `${embeddable ? 'Embeddables-' : ''}${capitalize(utmSource)}`,
    utm_medium: 'partner-app-store',
    ...currentParams,
  };
  window.location.assign(
    `${window.location.origin}${window.location.pathname}?${qs.stringify(newParams)}`,
  );
};

export const checkForEmbeddablePartner = (queryString: string): string | undefined => {
  const queryParams = qs.parse(queryString, {
    ignoreQueryPrefix: true,
    decoder: decodeURIComponent,
  });
  if (queryParams.utm_source) {
    return (queryParams.utm_source as string).toLowerCase();
  } else return undefined;
};
